import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import Button from "../../components/Button";
import ScoreFunction from "../../components/ScoreFunction"



class VTestEnd extends Component {

constructor(props) {
    super(props);

this.handleClick = this.handleClick.bind(this)

}

handleClick(){this.props.practiceTaskId(["Training01", "/Training/Practice2"])};


render() {
    
	const taskResult1 = this.props.testBoardStatesArray["Test01"]
	const score1 = ScoreFunction(this.props.testBoardStatesArray["Test01"],"VTest01")
	const taskResult2 = this.props.testBoardStatesArray["Test02"]
	const score2 = ScoreFunction(this.props.testBoardStatesArray["Test02"],"VTest02")
	const taskResult3 = this.props.testBoardStatesArray["Test03"]
	const score3 = ScoreFunction(this.props.testBoardStatesArray["Test03"],"VTest03")
	
	const score = averageFunction([score1,score2,score3])
	
	const detailedResults = JSON.stringify({"taskResult1":taskResult1, "score1":score1, 
											"taskResult2":taskResult2, "score2":score2,
											"taskResult3":taskResult3, "score3":score3,
											"total_score": score,
											"token": tokenFunction(score)
											})
	
	 
	
	
	
	return (
	<div> 
		
		<InstructionContainer>
			<h1> Test End </h1>
			<h2>  </h2>
			<P>
				You completed the test. <br/>
				The token below is your answer to the qualification test. Select this token as your response in 
				the qualification test in the MTurk interface to get your grade.
			</P>
			<DataToCopy value= {tokenFunction(score)} />
			<P>
			Please close this window. 
			</P>
			<br/>
			{/*
			<p> Alternative instructions for ONLP lab members: <br/> 
			Please copy the text below to the Google Sheet. <br/>
			You are encouraged to take this test once again and to generate different scores in order to debug it.
			</p>
			
			<DataToCopy primary value= {detailedResults} /> 
			*/}	
			
		</InstructionContainer>
		
	</div>
	);
	}
}
export default VTestEnd;

const averageFunction = (arr) => Math.round (arr.reduce((a,b) => a + b, 0) / arr.length)

const scoreToken = {
		100: 452227, 95: 660130,
		90:  238222, 85: 174032,
		80: 342913, 75: 824739,
		70: 546141, 65: 331154,
		60: 318222, 55: 883451,
		50: 793993, 0: 473003,
}
const tokenFunction =(score) => {	
	if (score == 100) {return (scoreToken[100])}
	else if (score >=95) {return (scoreToken[95])}
	else if (score >=90) {return (scoreToken[90])}
	else if (score >=85) {return (scoreToken[85])}
	else if (score >=80) {return (scoreToken[80])}
	else if (score >=75) {return (scoreToken[75])}
	else if (score >=70) {return (scoreToken[70])}
	else if (score >=65) {return (scoreToken[65])}
	else if (score >=60) {return (scoreToken[60])}
	else if (score >=55) {return (scoreToken[55])}
	else if (score >=50) {return (scoreToken[50])}
	else if (score >=0) {return (scoreToken[0])}
	else {return (score)};	
}


// justify-content: center;
// align-items: center;
// display: column;

// layout
const InstructionContainer = styled.div`
background: lightblue;
margin: 1em;
width: 90vw;


 ${props => props.primary && css `  //that's for displaying app component
    background: #e0e0e0;
	max-width: 60vw;
	margin: auto;
  `}

`;
 
const P = styled.p`
text-align: left;
font-size: large;

	${props => props.primary && css `  //that's for displaying app component
    font-size: small;
	`}

`;

const InstructionImage = styled.img`
overflow: scroll;
width: 90vw;
margin: 1em;

`;

const StyledButton = styled(Button)`
  width: 25%;
`;

const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  padding: 20px 10px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 300ms;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const DataToCopy = styled.textarea`
  width: 50vw;
  height: 1vh;
  ${props => props.primary && css `  
    height: 30vh;
	width: 80vw;
	`}
  align-self: center;
  margin-bottom: 1rem;
  color: darkblue;
  font-size: 12px;
  padding: 8px;
`;
